module.exports = __webpack_public_path__ + "static/media/wizualizacja-61.d7a18700.png";